export async function getHjulskifte(hjulskifte_key:string) {
    console.log('get-hjulskifte.ts')
    const reactAppData = window.react_data.api_url ? window.react_data : {api_url:'http://localhost:8000/api/v1/'};
    const endPoint = 'hjulskifte';

    let data = new FormData();
    data.append('hjulskifte_key', hjulskifte_key);

    return await fetch(reactAppData.api_url+endPoint, {body: data, method: 'post'})
        .then(res => res.json())
        .then(
            (result) => {
                return result
            },
            (error) => {
                return {error: error}
            }
        );
}
